import FieldDateRange from "../date-range/date-range"
import FieldConfig from "../../../proto/field-config"
import FieldDateDue_Popover from "./components/popover/popover"
import {convertToMomentRangeFromValue} from "../../../../gd/convert/moment-range"
import formatDate from "../../../../gd/format/date"

const debug = false
// const debug = "FieldDateStartDue"

export default class FieldDateStartDue extends FieldDateRange {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Date due"
        this.typeDescription    = 'Start-Due date field'

        this.label              = "Due date" // is used for picker hint

        this.components.PopoverMenu             = FieldDateDue_Popover
    }

    getViewValue(model:any) {
        let res
        const value = _.get(model, this.fieldId, null)

        if (value) {
            if (!!value.start && !!value.end) {
                res = convertToMomentRangeFromValue(value)
            } else if (!!value.end) {
                res = {
                    start   : null,
                    end     : momentDate(value.end)
                }
            }
        }

        debug && console.log(debug, 'getViewValue', res, value)

        return res
    }

    getDisplayValue(value: any): boolean | string {
        let res: any = false
        if (value) {
            if (!!value.start && !!value.end) {
                const daterange = convertToMomentRangeFromValue(value)
                res = "{0} - {1}".f(formatDate(daterange.start), formatDate(daterange.end))
            } else if (!!value.end) {
                res = formatDate(value.end)
            }
        }

        debug && console.log(debug, 'getDisplayValue', res, value)

        return res
    }
}
